<div class="detail-page-card">
    <div class="detail-page-card-title">{{ 'devCodeExecutions.title' | t }}</div>
    <div class="detail-page-card-body padded form-group-styling cerrix-control-sm">
        <cerrix-checkbox
            data-uiid="dev-code-executions-testrun"
            [label]="'devCodeExecutions.performAsTestrun' | t"
            [(value)]="testrunSelected"
        ></cerrix-checkbox>
        <small class="text-muted ms-2">{{ 'devCodeExecutions.rollbackHint' | t }}</small>
        <div class="row mt-2">
            <div class="col">
                <ng-select
                    id="executableSelect"
                    name="executableSelect"
                    [items]="executables"
                    [(ngModel)]="selectedExecutable"
                    bindLabel="Value"
                    bindValue="Key"
                    [closeOnSelect]="true"
                    [multiple]="false"
                    [clearable]="false"
                    [loading]="!executables"
                >
                </ng-select>
            </div>
            <button class="btn btn-light btn-sm" (click)="execute()">{{ 'devCodeExecutions.execute' | t }}</button>
        </div>

        @if (executionMessage) {
            <div>
                <hr />
                <pre>{{ executionMessage }}</pre>
            </div>
        }
    </div>
</div>
